import type { WorkspaceAppManifest } from './workspaceManifest';

export const APP_MANIFEST = {
    appId: 'project-management',
    permissionsPrefix: 'project',
    displayName: 'Project Management',

    navSections: [
        { key: 'dashboard', label: 'Dashboard', route: '/project-management/dashboard' },
        { key: 'projects', label: 'Projects', route: '/project-management/projects' },
        { key: 'configuration', label: 'Configuration', route: '/project-management/configuration' },
    ],

    resources: [
        {
            key: 'projectInfo',
            label: 'Projects',
            navSection: 'projects',
            recordRuleFields: [
                { field: 'ProjectManagerId', operators: ['eq'] },
                { field: 'CompanyID', operators: ['eq'] },
                { field: 'Status', operators: ['eq', 'neq', 'in', 'notin'] },
            ],
        },
        { key: 'projectCategory', label: 'Project Categories', navSection: 'configuration' },
        { key: 'projectRole', label: 'Project Roles', navSection: 'configuration' },
        { key: 'projectMember', label: 'Project Team Members', navSection: 'projects' },
        { key: 'projectWbs', label: 'Work Breakdown Structure', navSection: 'projects' },
        { key: 'projectTask', label: 'Project Tasks', navSection: 'projects' },
        { key: 'projectTaskDependency', label: 'Task Dependencies', navSection: 'projects' },
        { key: 'projectBudget', label: 'Project Budgets', navSection: 'projects' },
        { key: 'projectBudgetDetail', label: 'Project Budget Lines', navSection: 'projects' },
        { key: 'projectPaymentSchedule', label: 'Payment Schedules', navSection: 'projects' },
        { key: 'projectLaborType', label: 'Labour Types', navSection: 'configuration' },
        { key: 'projectLaborRate', label: 'Project Labour Rates', navSection: 'projects' },
        { key: 'projectMilestone', label: 'Project Milestones', navSection: 'projects' },
        { key: 'projectIssue', label: 'Project Issues', navSection: 'projects' },
        { key: 'projectRisk', label: 'Project Risks', navSection: 'projects' },
        { key: 'projectChangeRequest', label: 'Change Requests', navSection: 'projects' },
        { key: 'projectTimesheet', label: 'Timesheets', navSection: 'projects' },
        { key: 'projectDocument', label: 'Project Documents', navSection: 'projects' },
    ],
} satisfies WorkspaceAppManifest;
